import { useState } from "react";
import { Marker, useMapEvents } from "react-leaflet";

function LocationMarker(props) {
  const [position, setPosition] = useState(null);
  useMapEvents({
    click(e) {
      setPosition(e.latlng);
      props.passGuess([e.latlng.lat, e.latlng.lng]);
    },
  });
  return position === null ? null : (
    <Marker position={position} icon={props.icon}>
      {/* <Popup>
        Latlong is: {position.lat.toFixed(4)}, {position.lng.toFixed(4)}
      </Popup> */}
    </Marker>
  );
}
export default LocationMarker;
